import type { Integration } from "@prescreen/lib/types"
import IntegrationForm from "./IntegrationForm"

interface CreateIntegrationTabProps {
  onIntegrationCreated?: (integration: Integration) => void
}

export default function CreateIntegrationTab({
  onIntegrationCreated,
}: CreateIntegrationTabProps) {
  return (
    <IntegrationForm
      onIntegrationSaved={onIntegrationCreated ?? (() => {})}
    />
  )
}